// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__29vUS","error":"Textarea_error__1Q9-T","readonly":"Textarea_readonly__3EsLk","disabled":"Textarea_disabled__qCAlr"};